<template>
  <div>
    <div v-if="!isReadOnly" class="d-flex justify-content-end">
      <action-button
        i="fas fa-file-plus"
        text="Añadir Prueba"
        variant="success pl-3 pr-3 my-3"
        @click="add()"
      />
    </div>
    <validation-provider
      v-slot="{ errors }"
      name="Información de prueba"
      rules="required"
    >
      <input
        type="hidden"
        :value="model.infoTests && model.infoTests.length ? 'OK' : ''"
      />

      <div v-if="errors[0]" class="custom-error mb-2">
        <i class="fas fa-times-circle mr-2" />
        Debe agregar al menos una información de prueba antes de guardar.
      </div>

      <div
        v-for="item in model.infoTests"
        :key="item.id || item._uid"
        class="mb-4"
      >
        <div class="bg-light p-3 rounded">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <label class="text-muted">Información de Prueba:</label>

            <i
              v-if="!isReadOnly"
              class="far fa-times-circle text-danger"
              @click="remove(item)"
            />
          </div>

          <validation-provider v-slot="{ errors }" rules="required">
            <custom-text-area
              v-model="item.comment"
              :count-classes="['d-block', 'small-counter', 'text-right']"
              custom-error-msg="El campo es requerido"
              :disabled="isReadOnly"
              :error="errors[0]"
              :maxlength="5000"
              :show-char-count="!isReadOnly"
            />
          </validation-provider>
        </div>
      </div>
    </validation-provider>
  </div>
</template>

<script>
// components
import CustomTextArea from 'CustomTextArea';
import ActionButton from 'ActionButton';

//utils
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';

export default {
  name: 'OtherAcademicTests',
  components: {
    CustomTextArea,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => ({
        infoTests: [],
      }),
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    model: {
      get() {
        return this.value || { infoTests: [] };
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    add() {
      this.model.infoTests.push({ comment: '' });
    },
    async remove(item) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar esta información de prueba?',
        'Sí',
        'No'
      );
      if (!answer) return;
      this.model.infoTests.splice(this.model.infoTests.indexOf(item), 1);
    },
  },
};
</script>
<style>
.custom-error {
  text-align: left;
  font: Lato, Regular;
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 0;
  font-weight: 400;
}
</style>
